import { useCallback } from 'react';
import { useMapDrawerEntityForPoiState } from 'state/useMapDrawerEntityForPoiState';
import { ExternalFeatureProperties } from './ExternalFeatureLayer.types';
import { MapboxFeature } from '../useMapLayerEvents';

type UseLayerClickHandler = (
  features: MapboxFeature<ExternalFeatureProperties>[],
) => void;

export const useLayerClickHandler = (
  sourceId: string,
): UseLayerClickHandler => {
  const { setMapDrawerEntityForPoi } = useMapDrawerEntityForPoiState();

  const clickHandler = useCallback(
    (features: MapboxFeature<ExternalFeatureProperties>[]) => {
      const feature = features[0];

      setMapDrawerEntityForPoi({
        id: feature.id,
        type: sourceId,
        metadata: feature.properties,
      });
    },
    [setMapDrawerEntityForPoi, sourceId],
  );

  return clickHandler;
};
